<template>
    <b-container fluid="sm" v-if="privacyDocument" class="pt-2 pb-2">
        <b-row>
            <b-col md="12">
                <privacy-document-view
                    :document="privacyDocument"
                >
                    <template #title v-if="versionSelected && versionSelected.version">
                        <span>{{$t("org.auth.privacyPolicy")}} ({{ versionSelected.version }})</span>
                    </template>
                    <template #topright  v-if="versions.length">
                        <v-select v-model="versionSelected" label="label" :clearable="false" :options="versions" />
                    </template>
                </privacy-document-view>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import vSelect from 'vue-select'
import useAppConfig from '@core/app-config/useAppConfig'
import { getCurrentInstance, computed, ref, watch, toRefs } from '@vue/composition-api'
import PrivacyDocumentView from './components/PrivacyDocumentView'
export default {
    components: {
        vSelect,
        PrivacyDocumentView
    },
    props: {
        locale: {
            type: String,
            default: 'ko'
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        const { locale, theme } = toRefs(props)
        const { skin } = useAppConfig()

        /* data */
        /* const xmlParser = require('xml2js') */
        const versions = ref([])
        const versionSelected = ref({
            label: '',
            value: '',
            version: null
        })
        const versionNum = ref('')

        /* computed */
        const privacyDocument = computed(() => store.getters.privacyDocument)

        /* methods */
        const getPrivacyDocument = () => {
            store.dispatch('getPrivacyDocumentContent', { version: versionSelected.value.value, locale: locale.value })
        }

        /* watch */
        watch(versionSelected, (value) => {
            getPrivacyDocument()
        })

        /* init */
        vm.$i18n.locale = locale.value
        localStorage.setItem('locale', locale.value)
        skin.value = theme.value
        store.dispatch('getPrivacyDocumentVersions', { locale: locale.value }).then((data) => {
            versions.value = data.data.map(content => {
                return {
                    label: content.replace('.json', ''),
                    value: content.replace('.json', ''),
                    version: content.replace('.json', '')
                }
            }).sort((a, b) => a.value > b.value ? -1 : 1)
            versionSelected.value = versions.value[0]
        })
        return {
            versions,
            versionSelected,
            versionNum,
            privacyDocument,
            getPrivacyDocument
        }
    }
}
</script>

<style>
.dark-layout .collapse-style .table-bordered.table-sm tbody tr th {
    color:#000
}
</style>
